var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-overlay',{attrs:{"show":_vm.show,"variant":_vm.variant,"opacity":_vm.opacity,"blur":_vm.blur,"rounded":"lg","spinner-variant":"primary"}},[_c('b-card',[_c('div',{staticClass:"p-5"},[_c('h2',[_vm._v(_vm._s(_vm.confirm))])])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }